module.exports = __webpack_public_path__ + "static/media/cert_124.b8f33b1b.jpg";